<template>
    <v-container >
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <h1 class="mb-3 heading deep-purple--text text--accent-3">Konteineri</h1>
                </v-flex>

                <v-spacer></v-spacer>

                <v-flex xs10 sm4 >
                    <v-text-field
                            @input="searchContainers"
                            v-model="search"
                            append-icon="search"
                            label="Meklēt"
                            single-line
                            color="deep-purple accent-3"
                            class="mb-2"
                    ></v-text-field>
                </v-flex>
                <v-flex v-if="!showForm" xs2 sm1 class="pt-2 text-xs-right">
                    <v-tooltip top>
                        <v-btn  @click="showAddContainerForm" small outline fab color="deep-purple" slot="activator">
                            <v-icon >add</v-icon>
                        </v-btn>
                        <span>Pievienot konteineru</span>
                    </v-tooltip>
                </v-flex>
                <v-flex v-if="showForm" xs2 sm1 class="pt-2 text-xs-right">
                        <v-btn  @click="hideAddContainerForm" small outline fab color="deep-orange lighten-1" slot="activator">
                            <v-icon >block</v-icon>
                        </v-btn>

                </v-flex>

            </v-layout>

        <add-container v-if="showForm"></add-container>

        <template v-if="containers">
            <v-card flat v-for="container in containers.data" :key="container.regNr">
                <v-layout row wrap class="pa-3 mb-1">
                    <v-flex xs6 md3>
                        <div class="caption grey--text">Konteinera Nr</div>
                        <div>{{container.regNr}}</div>
                    </v-flex>
                    <v-flex xs6 md3>
                        <div class="caption grey--text">Īpašnieks</div>
                        <div>{{container.company}}</div>
                    </v-flex>
                    <v-flex xs6 md3>
                        <div class="caption grey--text">Ražošanas gads</div>
                        <div>{{container.year}}</div>
                    </v-flex>
                    <v-flex xs6 md2>
                        <div class="caption grey--text">Tilpums</div>
                        <div>{{container.volume}}</div>
                    </v-flex>
                    <v-flex xx12 sm4 md1>
                        <v-layout row wrap>
                            <v-flex xs6>
                                <v-tooltip top>
                                    <v-btn icon to="" flat small slot="activator">
                                        <v-icon color="grey">open_in_new</v-icon>
                                    </v-btn>
                                    <span>Skatīt konteineru</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs6>
                                <v-tooltip top>
                                    <v-btn icon @click="deleteContainer(container.id)" flat small slot="activator">
                                        <v-icon color="grey">delete</v-icon>
                                    </v-btn>
                                    <span>Dzēst konteineru</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <v-layout row>
                <v-flex v-if="containers.meta.last_page > 1" sm6  offset-sm4>
                    <v-pagination
                            v-model="containers.meta.current_page"
                            :length="containers.meta.last_page"
                            :total-visible="5"
                            color="deep-purple accent-3"
                            @input="onPageChange"
                    ></v-pagination>
                </v-flex>
            </v-layout>
        </template>

        <v-snackbar
                v-model="snackbar"
                :color="color"
                :timeout="timeout"
                auto-height
                right
        >
            {{ text }}
            <v-btn dark
                   flat
                   @click="snackbar = false"
            >X</v-btn>
        </v-snackbar>

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import AddContainer from "../components/AddContainer.vue";

    export default {
        name: "Containers",
        components: {AddContainer},
        data: () => ({
            snackbar: false,
            color: '',
            timeout: 2000,
            text: ''
        }),
        mounted() {
            this.$store.dispatch('hideAddContainerForm')
            this.$store.dispatch('resetSearch')
            this.$store.dispatch('getContainers')
        },
        computed: {
            ...mapGetters({
                containers: 'containers',
                search: 'search',
                showForm: 'showAddContainerForm'
            })
        },
        methods: {
            searchContainers(value){
                this.$store.dispatch('changeSearch', value)
                this.$store.dispatch('getContainers')
            },
            onPageChange() {
                this.$store.dispatch('getContainers', this.containers.meta.current_page);
            },
            showAddContainerForm(){
                this.$store.dispatch('showAddContainerForm')
            },
            hideAddContainerForm(){
                this.$store.dispatch('hideAddContainerForm')
            },
            deleteContainer(containerId){
                if(confirm('Vai esi drošs?')){
                    this.$Progress.start()
                    this.$store.dispatch('deleteContainer', containerId)
                    this.snackbar = true
                    this.color = 'red'
                    this.text = 'Konteiners dzēsts'
                }
            }



        }
    }
</script>

<style scoped>

</style>